export default __webpack_public_path__ + "static/media/right-align.0af43e00.svg";